import {crudStorage} from "./crudStorage";
import {viewFiles} from "./viewFiles";

export function deleteItem(
  dashState,
  path,
  fileName,
  setFiles,
  setSelectedFile,
  toast,
  onDeleteSuccess
) {
  // Only allow deletion of files in Client Uploads folder
  if (!path.includes('/Client Uploads')) {
    toast({
      title: "Permission denied",
      description: "You can only delete files you uploaded",
      status: "error",
      duration: 3000,
      isClosable: true,
    });
    return;
  }
  
  const isFolder = fileName?.endsWith("/");
  
  // Show immediate feedback
  toast({
    title: `Deleting ${isFolder ? "folder" : "file"}...`,
    status: "info",
    duration: 1500,
    isClosable: true,
  });
  
  // Perform the actual deletion
  crudStorage(
    dashState,
    isFolder ? "deleteDirectory" : "deleteFile",
    isFolder ? "" : path + fileName,
    dashState.organization?.s3BucketName || "brightlighthealth",
    isFolder ? path + fileName : "",
  )
    .then(() => {
      toast({
        title: `${isFolder ? "Folder" : "File"} deleted`,
        description: `Successfully deleted ${fileName}`,
        status: "success",
        duration: 3000,
        isClosable: true,
      });
      
      // Clear selection
      setSelectedFile("");
      
      // Call the success callback if provided to trigger parent refresh
      if (onDeleteSuccess) {
        onDeleteSuccess();
      } else {
        // Fallback: refresh from server to ensure consistency
        const rootPath = dashState?.patient?.pid ? `${dashState.patient.pid}/` : "";
        viewFiles(dashState, setFiles, setSelectedFile, rootPath, toast);
      }
    })
    .catch((err) => {
      console.error("Delete error:", err);
      toast({
        title: "Delete failed",
        description: `Could not delete ${fileName}`,
        status: "error",
        duration: 3000,
        isClosable: true,
      });
      
      // Restore the file list on error
      const rootPath = dashState?.patient?.pid ? `${dashState.patient.pid}/` : "";
      viewFiles(dashState, setFiles, setSelectedFile, rootPath, toast);
    });
}